import React from "react";
import "./Franchise.scss"
import InvestorCard from "./FranchiseComponents/InvestorCard/InvestorCard";

import { sortByOrderAscending } from "../../../../Hospitality/helper/helper";

const FranchiseInvestors = ({ components }) => {

    const getComponents = (component) => {
        switch (component.ID) {
            case "Header":
                return <div className="Franchise-investors-headers">
                    {component?.Props?.content}
                </div>
            case "investor-card-grid":
                return <div className="Franchise-investors-cardgrid">
                    {component?.Props?.cardData?.map((item, key) => {
                        return (
                            <InvestorCard item={item} key={key} />

                        )
                    })}

                </div>
            default:
                return <div />
        }

    }
    return (
        <div className="Franchise-investors">


            {sortByOrderAscending(components).map((component) => {
                return getComponents(component)
            })}

        </div>
    )
}
export default FranchiseInvestors